// extracted by mini-css-extract-plugin
module.exports = {"inner":"PlanIcon_inner__en_tL","icon":"PlanIcon_icon__mjh1v","plus":"PlanIcon_plus__BRS7p","pro":"PlanIcon_pro__FFWBM","essentials":"PlanIcon_essentials__3pWhc"};